import angular from 'angular';
import customerCareTabFilter from './customerCareTabFilter';
import customerCareExportButtons from './customerCareExportButtons';

export default angular
  .module('customerCareTab.components', [])
  .component('customerCareTabFilter', customerCareTabFilter)
  .component('customerCareExportButtons', customerCareExportButtons).name;
